import { useState, useEffect, useRef } from 'react';

export default function useOutisdeClick(initialIsVisible) {
  const [isOpen, setOpen] = useState(initialIsVisible);
  const ref = useRef(null);

  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return { ref, isOpen, setOpen };
}
